import { createSlice, PayloadAction } from '@reduxjs/toolkit';

import { commonApiTypes } from 'types/common';
import { logOutReducerTypes } from 'types/store/auth/logOut';
import { COOKIES_NAME } from 'utils/constants/common';
import { removeCookie } from 'utils/helpers/cookieFunc';

import { logOutState } from './logOutState';

const logOutSlice = createSlice({
    name: 'logOut',
    initialState: logOutState,
    reducers: {
        logOutStart: (state) => {
            return {
                ...state,
                isLoading: true,
            };
        },
        logOutSuccess: (state, action: PayloadAction<logOutReducerTypes.ILogOutResponse>) => {
            removeCookie(COOKIES_NAME.TOKEN, false, '');
            removeCookie(COOKIES_NAME.IS_LOG_IN, true, '/login');
            return {
                ...state,
                ...action.payload,
                isLoading: false,
                isLogOutSuccess: true,
                password: '',
                email: '',
            };
        },
        logOutFailed: (state, action: PayloadAction<commonApiTypes.IApiFailed>) => {
            removeCookie(COOKIES_NAME.TOKEN, false, '');
            removeCookie(COOKIES_NAME.IS_LOG_IN, true, '/login');
            return {
                ...state,
                ...action.payload,
                isLoading: false,
                isLogOutSuccess: false,
                password: '',
                email: '',
            };
        },
        loginReset: () => {
            return {
                ...logOutState,
            };
        },
    },
});

export { logOutSlice };
